import { NgModule } from '@angular/core'
import { CommonModule } from '@angular/common'
import { RouterModule } from '@angular/router'
import { ProfileCandidateDetailsComponent } from './profile-candidate-details.component'
import { ProfileComponent } from './profile.component'
import { ProfileWithVoterComponent } from './profile-with-voter.component'
import { SharedModule } from '../shared/shared.module'
import { SmartspiderModule } from '@smartvote/components'
import { CdkAccordionModule } from '@angular/cdk/accordion'
import { FormsModule } from '@angular/forms'
import { QuestionItemComponent } from './question-item.component'
import { AnswerOptionItemComponent } from './answer-option-item.component'
import { AnswerOptionGroupComponent } from './answer-option-group.component'

const COMPONENTS = [
  ProfileComponent,
  ProfileWithVoterComponent,
  ProfileCandidateDetailsComponent,
  QuestionItemComponent,
  AnswerOptionItemComponent,
  AnswerOptionGroupComponent
]

@NgModule({
  imports: [
    CommonModule,
    SharedModule,
    SmartspiderModule,
    CdkAccordionModule,
    RouterModule,
    FormsModule
  ],
  declarations: COMPONENTS,
  exports: COMPONENTS
})
export class ProfileModule {}
